var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppstore = function SvgAppstore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0341 14.7632C22.0089 11.7311 24.3227 10.256 24.4286 10.1874C23.1182 8.11489 21.0871 7.83172 20.3734 7.80915C18.6676 7.61441 17.0129 8.91641 16.144 8.91641C15.2577 8.91641 13.9196 7.82795 12.4774 7.85994C10.6216 7.89099 8.8854 9.05658 7.93321 10.8666C5.9681 14.5572 7.43369 19.9806 9.31642 22.9637C10.2582 24.4256 11.3587 26.056 12.7991 25.9985C14.2084 25.9365 14.7348 25.0239 16.4354 25.0239C18.1204 25.0239 18.6147 25.9985 20.0838 25.961C21.5962 25.9364 22.5484 24.4943 23.4572 23.0192C24.5456 21.3465 24.9826 19.6956 25 19.6109C24.9653 19.5987 22.0636 18.3973 22.0341 14.7632ZM19.2591 5.84674C20.017 4.81849 20.5356 3.41959 20.3916 2C19.2946 2.05268 17.9226 2.82316 17.1326 3.82883C16.4337 4.71501 15.8093 6.16753 15.9706 7.53351C17.2029 7.63322 18.4681 6.85898 19.2591 5.84674Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppstore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appstore.575db9eb.svg";
export { ForwardRef as ReactComponent };